import type {ApolloCache} from "apollo-cache";
import {
    defaultDataIdFromObject,
    InMemoryCache,
    IntrospectionFragmentMatcher,
} from "apollo-cache-inmemory";

import introspectionQueryResultData from "./fragment-types.ts";

// https://www.apollographql.com/docs/angular/features/cache-updates/#normalization-with-dataidfromobject
// Some types not have a guaranteed unique id. Because of this,
// the cacheId is unique and we should use this.  We've added this as a
// "graphql/required-fields" eslint rule, so anything that queries it should
// have the cacheId.  Anything else, just use the default ID function
function dataIdFromObject(o: any): string {
    if (o.cacheId) {
        return o.__typename + ":" + o.cacheId;
    }

    // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
    return defaultDataIdFromObject(o);
}

/**
 * Create an InMemoryCache instance for use with Apollo Client.
 */
export default (addTypename = true): ApolloCache<any> =>
    new InMemoryCache({
        addTypename,
        fragmentMatcher: new IntrospectionFragmentMatcher({
            introspectionQueryResultData,
        }),
        dataIdFromObject,
    }) as TSFixMe<"this works fine, not sure why TS is complaining">;
